import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyAllyShopGridPromo = loadable(() => import(/* webpackChunkName: "content/registry/ally-shop-grid-promo" */ './AllyShopGridPromo'), 'AllyShopGridPromo');
